<template>
<div>
  <form @submit.prevent="submit" id="gateway_form"
        :style="loading ? 'filter: blur(5px); cursor: not-allowed': ''">

    <kt-col class="container p-3 pt-5 my-4 border in-border-header">
      <kt-form-section>
        <div class="section-header bg-white">
          {{ $t('label.shop_data') }}
        </div>
        <kt-row>
          <kt-col lg="6" md="6" xs="12">
            <kt-form-group>
              <kt-form-label for="farsi_name">
                {{ $t('label.farsi_name') }}
              </kt-form-label>
              <kt-form-control
                  id="farsi_name"
                  name="farsi_name"
                  v-model="form_data.farsi_name"
              >
              </kt-form-control>
            </kt-form-group>
          </kt-col>

          <kt-col lg="6" md="6" xs="12">
            <kt-form-group>
              <kt-form-label for="english_name">
                {{ $t('label.english_name') }}
              </kt-form-label>
              <kt-form-control
                  id="english_name"
                  name="english_name"
                  v-model="form_data.english_name"
                  dir="ltr"
              >
              </kt-form-control>
            </kt-form-group>
          </kt-col>
        </kt-row>
        <kt-row>
          <kt-col lg="12" md="12" xs="12">
            <kt-form-group>
              <kt-form-label for="subcategory_code">
                {{ $t('label.subcategory_code') }}
              </kt-form-label>
              <select
                  id="subcategory_code"
                  name="subcategory_code"
                  v-model="form_data.subcategory_code"
                  class="form-control kt-selectpicker"
              >
                <option
                    v-bind:key="subcategory.key"
                    v-for="subcategory in subcategories"

                    :value="subcategory.key"
                >
                  {{ subcategory.value }}
                </option>
              </select>
            </kt-form-group>
          </kt-col>
        </kt-row>
        <kt-row v-if="form_data.merchant_type == 1">
          <kt-col lg="6" md="6" xs="12">
            <kt-form-group>
              <kt-form-label for="address">
                {{ $t('label.address') }}
              </kt-form-label>
              <select
                  v-if="addresses"
                  id="address"
                  name="address"
                  v-model="form_data.address"
                  class="form-control kt-selectpicker"
              >
                <option
                    v-bind:key="address.id"
                    v-for="address in addresses"

                    :value="address.id"
                >
                  {{ address.address }}
                </option>
              </select>
            </kt-form-group>
          </kt-col>
          <kt-col lg="3" md="3" xs="12">
            <kt-form-group>
              <kt-form-label for="telephone">
                {{ $t('label.telephone') }}
              </kt-form-label>
              <kt-form-control
                  dir="ltr"
                  id="telephone"
                  name="telephone"
                  v-model="form_data.telephone"
              >
              </kt-form-control>
            </kt-form-group>
          </kt-col>
          <kt-col lg="3" md="3" xs="12">
            <kt-form-group>
              <kt-form-label for="tax_payer_code">
                {{ $t('label.tax_payer_code') }}
              </kt-form-label>
              <kt-form-control
                  dir="ltr"
                  id="tax_payer_code"
                  name="tax_payer_code"
                  v-model="form_data.tax_payer_code"
              >
              </kt-form-control>
            </kt-form-group>
          </kt-col>
        </kt-row>
        <kt-row v-else>
          <kt-col lg="6" md="6" xs="12">
            <kt-form-group>
              <kt-form-label for="address">
                {{ $t('label.address') }}
              </kt-form-label>
              <select
                  v-if="addresses"
                  id="address"
                  name="address"
                  v-model="form_data.address"
                  class="form-control kt-selectpicker"
              >
                <option
                    v-bind:key="address.id"
                    v-for="address in addresses"

                    :value="address.id"
                >
                  {{ address.address }}
                </option>
              </select>
            </kt-form-group>
          </kt-col>
          <kt-col lg="6" md="6" xs="12">
            <kt-form-group>
              <kt-form-label for="telephone">
                {{ $t('label.telephone') }}
              </kt-form-label>
              <kt-form-control
                  dir="ltr"
                  id="telephone"
                  name="telephone"
                  v-model="form_data.telephone"
              >
              </kt-form-control>
            </kt-form-group>
          </kt-col>
          <kt-col lg="6" md="6" xs="12">
            <kt-form-group>
              <kt-form-label for="phone_number">
                {{ $t('label.phone_number') }}
              </kt-form-label>
              <kt-form-control
                  dir="ltr"
                  id="phone_number"
                  name="phone_number"
                  v-model="form_data.phone_number"
              >
              </kt-form-control>
            </kt-form-group>
          </kt-col>
          <kt-col lg="6" md="6" xs="12" v-if="form_data.birth_crtfct_number">
            <kt-form-group>
              <kt-form-label for="birth_crtfct_number">
                {{ $t('label.birth_crtfct_number') }}
              </kt-form-label>
              <kt-form-control
                  dir="ltr"
                  id="birth_crtfct_number"
                  name="birth_crtfct_number"
                  v-model="form_data.birth_crtfct_number"
              >
              </kt-form-control>
            </kt-form-group>
          </kt-col>
          <kt-col lg="6" md="6" xs="12">
            <kt-form-group>
              <kt-form-label for="tax_payer_code">
                {{ $t('label.tax_payer_code') }}
              </kt-form-label>
              <kt-form-control
                  dir="ltr"
                  id="tax_payer_code"
                  name="tax_payer_code"
                  v-model="form_data.tax_payer_code"
              >
              </kt-form-control>
            </kt-form-group>
          </kt-col>
        </kt-row>
        <kt-row>
          <kt-col xs="12">
            <kt-form-group>
              <kt-form-label for="sheba_number">
                {{ $t('label.sheba_number') }}
              </kt-form-label>
              <select
                  id="sheba_number"
                  name="sheba_number"
                  v-model="form_data.sheba"
                  class="form-control kt-selectpicker"
              >
                <option
                    v-bind:key="sheba_number.id"
                    v-for="sheba_number in sheba_numbers"

                    :value="sheba_number.id"
                >
                  {{ sheba_number.number }}
                </option>
              </select>
            </kt-form-group>
          </kt-col>
        </kt-row>
        <kt-row>
          <kt-col lg="6" md="6" xs="12">
            <kt-form-group>
              <kt-form-label for="site_address">
                {{ $t('label.site_address') }}
              </kt-form-label>
              <kt-form-control
                  dir="ltr"
                  id="site_address"
                  name="site_address"
                  placeholder="https://mysite.ir/"
                  disabled
                  :value="form_data.site_address">
              </kt-form-control>
            </kt-form-group>
          </kt-col>
          <kt-col lg="6" md="6" xs="12">
            <kt-form-group>
              <kt-form-label for="server_ip">
                {{ $t('label.server_ip') }}
              </kt-form-label>
              <kt-form-control
                  dir="ltr"
                  id="server_ip"
                  name="server_ip"
                  v-model="form_data.server_ip"
              >
              </kt-form-control>
            </kt-form-group>
          </kt-col>
        </kt-row>
        <kt-row>
          <kt-col lg="6" md="6" xs="12">
            <kt-form-group>
              <kt-form-label for="wage">
                {{ $t('label.wage') }}
              </kt-form-label>
              <select
                  id="wage"
                  name="wage"
                  v-model="
                            (
                                form_data.merchant_share_percent != 0 &&
                                form_data.merchant_share_percent != 100
                            ) ?
                            wage_s = 50:
                            form_data.merchant_share_percent"
                  @change="selectChange($event)"
                  class="form-control kt-selectpicker"
              >
                <option
                    v-for="wage in wages"
                    v-bind:key="wage.id"
                    :value="wage.id"
                >
                  {{ wage.value }}
                </option>
              </select>
            </kt-form-group>
          </kt-col>

          <kt-col v-if="(
                    form_data.merchant_share_percent != 0 &&
                    form_data.merchant_share_percent != 100
                )" lg="3" md="3" xs="12">
            <kt-form-group>
              <kt-form-label for="merchant_wage_share">
                {{ $t('label.merchant_wage_share') }}
              </kt-form-label>
              <input
                  type="number"
                  max="100"
                  min="0"
                  id="merchant_share_percent"
                  name="merchant_share_percent"
                  v-model="form_data.merchant_share_percent"
                  class="form-control kt-selectpicker"
              >
            </kt-form-group>
          </kt-col>

          <kt-col v-if="(
                    form_data.merchant_share_percent != 0 &&
                    form_data.merchant_share_percent != 100
                )" lg="3" md="3" xs="12">
            <kt-form-group>
              <kt-form-label for="client_wage_share">
                {{ $t('label.client_wage_share') }}
              </kt-form-label>

              <p
                  class="form-control disabled"
                  id="client_wage_share"
                  name="client_wage_share"
              >
                {{ !form_data.merchant_share_percent ? "" : 100 - form_data.merchant_share_percent }}
              </p>
            </kt-form-group>
          </kt-col>
          <div class="col-md-6">
            <div class="form-group form-check d-flex">
              <label class="switch">
                <input  type="checkbox" class="custom-control-input" id="has_limit2" name="has_limit"
                        v-model="form_data.abroad_ips_only_by_user">
                <span class="slider round"></span>
              </label>
              <p class="mx-3" dir="rtl">{{ $t('label.abroad_ip_limitation_by_user') }}</p>
            </div>
            <transition name="fade">
              <kt-form-group v-if="form_data.abroad_ips_only_by_user">
                <kt-form-label>
                  {{ $t('label.limit_amount') }}
                </kt-form-label>
                <div class="kt-input-icon kt-input-icon--right">
                    <span class="kt-input-icon__icon kt-input-icon__icon--right">
                        <span>{{ $t('label.rial') }}</span>
                    </span>
                  <kt-form-control
                      type="text"
                      dir="ltr"
                      id="limit_amount"
                      name="limit_amount"
                      v-model="form_data.limit_amount_by_user"
                  >
                  </kt-form-control>
                </div>
              </kt-form-group>
            </transition>
          </div>

          <kt-col lg="6" md="6" xs="12">
            <kt-form-group>
              <kt-form-label>
                {{ $t('label.logo') }}
              </kt-form-label>
              <kt-form-label for="logo_file" class="d-block btn btn-secondary btn-wide label-file">
                <kt-icon type="fa" name="paperclip"></kt-icon>
                {{ $t('gateway.btn.click_me') }}
              </kt-form-label>
              <input
                  @change="processLogoFile"
                  type="file"
                  class="custom-file-upload"
                  name="logo"
                  id="logo_file"
                  accept="image/*"
              />
            </kt-form-group>
          </kt-col>
        </kt-row>
      </kt-form-section>

      <kt-form-action class="mt-4">

        <div class="d-flex align-items-center px-3 mt-5">
          <div>
            <button
                type="button"
                class="btn btn-success px-4"
                style="border-radius: 10px"
                @click="--wizard.current_step"
            >
              مرحله قبل
            </button>
          </div>
          <div class="mr-auto">
            <button
                type="submit"
                class="btn btn-success px-4"
                style="border-radius: 10px"
                id="submit_btn"
                :disabled="form_submit_loading"
            >
            <span v-if="form_submit_loading">
              <span class="pl-2">در حال انجام</span>
              <span
                  class="spinner-border spinner-border-sm p-2"
                  role="status"
              ></span>
            </span>
              <span v-else>مرحله بعدی</span>
            </button>
          </div>
        </div>

      </kt-form-action>
    </kt-col>
  </form>

</div>
</template>

<script>
import $ from "jquery";
import Inputmask from "inputmask";
import {mapGetters} from "vuex";
import { userTypes } from '@/constants/userTypes';
import { subcategories } from '@/constants/subcategories'
import { gatewayStatus } from '@/constants/gatewayStatus'
import { i18n } from '@/plugins/i18n'
import {gatewayService} from "../../../common/api.service";
import { KTApp } from '@/plugins/core/app'
import { KTUtil } from '@/plugins/core/util'

export default {
  name: "gateway-edit.vue",
  components: {},
  props: {
    wizard: Object
  },
  data() {
    return {
      user_types: userTypes,
      subcategories: subcategories,
      wages: [
        {
          id: 0,
          value: this.$t('gateway.wages.from_payer')
        },
        {
          id: 100,
          value: this.$t('gateway.wages.from_me')
        },
        {
          id: 50,
          value: this.$t('gateway.wages.half')
        }
      ],
      gatewayStatus: gatewayStatus,
      loading: true,
      form_submit_loading: true
    }
  },
   mounted() {
       this.$nextTick(function () {
           // setTimeout(() => {
           //     Inputmask("https://[*{1,20}.]*{1,30}[.*{1,20}][.*{1,20}]").mask(
           //         document.querySelectorAll("#site_address")
           //     );
           // }, 1000);
       });
     this.$store.dispatch('gateway/fetchByUserId', this.current_user.id)
         .finally(() => {
            this.$store.dispatch('gateway/find', this.gateways.gateways[0].id).finally(()=>{
              this.loading = false
              this.form_submit_loading = false
            })
     })
     this.$store.dispatch('shebaNumber/fetch')

    this.$store.dispatch('address/fetch').finally(() => {
      this.afterDispatch()
    })
  },
  methods: {
    submit() {
      let btn = $('#submit_btn')
      let form = $('#gateway_form')

        form.validate({
            rules: {
                farsi_name:{
                    required: true,
                },
                english_name:{
                    required: true,
                },
                subcategory_code:{
                    required: true,
                },
                address:{
                    required: true,
                },
                telephone:{
                    required: true,
                },
                tax_payer_code:{
                    required: true,
                },
                logo:{
                    required: true,
                },
                sheba_number:{
                    required: true,
                },
                phone_number: {
                    required: true
                },
                server_ip: {
                    required: true
                },
                wage: {
                    required: true
                },
                merchant_share_percent: {
                    required: {
                        depends:() => {
                            return ($("#wage").val() == 50)
                        }
                    }
                }
            }
        })

        if (!form.valid())
            return false;

      KTApp.progress(btn)
        // this.form_data.site_address = "https://" + this.form_data.site_address

      gatewayService.update(this.form_data.id, this.form_data).then(response => {
        this.wizard.current_step = 4;
        this.showMsg(form, 'success', response.data.message)
      }).catch(({response}) => {
        if (response.data) {
          form.validate().showErrors(response.data.data)
        }
        this.showMsg(form, 'danger', response.data.message)
      })
          .finally(() => {
            KTUtil.scrollTop()
            KTApp.unprogress(btn)
          })

    },

    afterDispatch() {
      setTimeout(function () {
        $('.kt-selectpicker').selectpicker({
          size: 4,
          liveSearch: true,
          noneResultsText: i18n.t('selectpicker.none_result'),
          selectAllText: i18n.t('selectpicker.select_all'),
          noneSelectedText: i18n.t('selectpicker.nothing_selected')
        })
      }, 2000)

      document.getElementById('phone_number') && Inputmask('099-99999999').mask(document.getElementById('telephone'))
      document.getElementById('telephone') && Inputmask('09999999999').mask(document.getElementById('phone_number'))

    },
    processLogoFile(e) {
      this.form_data.logo = event.target.files[0];
      if (this.validateSize(event.target)) {
        this.validateFormat(event.target);
      }
    },
    selectChange(event){
      if (event.target.value == 0 || event.target.value == 100)
        this.form_data.merchant_share_percent = event.target.value
    },
    validateSize(file) {
      var FileSize = file.files[0].size / 1024 / 1024; // in MB
      if (FileSize > 1) {
        alert(i18n.t('authenticate.hint.fourth'));
        $(file).val('');
        return false;
      } else {

      }

      return true;
    },
    validateFormat(file) {
      let jq_file = $(file);
      let file_name = jq_file.val();
      let extension = file_name.replace(/^.*\./, '');
      if (extension === file_name) {
        extension = '';
      } else {
        extension = extension.toLowerCase();
      }

      switch (extension) {
        case "png":
        case "jpeg":
        case "jpg":
          break;
        default:
          alert(i18n.t('authenticate.input_format_err'));
          $(file).val('');
          return false;
      }

      return true;
    },
    checkIfShopRejectedByShaparak() {
      return this.form_data.status != gatewayStatus.REJECTED_BY_SHAPARAK
    }
  },
  computed: {
    ...mapGetters('address', [
      'addresses'
    ]),
    ...mapGetters('shebaNumber', [
      'sheba_numbers'
    ]),
    ...mapGetters('user', [
      'current_user'
    ]),
    ...mapGetters('gateway', ['gateways']),
    ...mapGetters('gateway', [
      'form_data'])
  },
}
</script>

<style scoped>
.label-file {
  border: 1px solid #ccc;
  width: fit-content;
  cursor: pointer;
  min-width: 200px;
}
input[type="file"]::-webkit-file-upload-button {
  visibility: hidden;
}
</style>